import { render, staticRenderFns } from "./MarcaUpdate.vue?vue&type=template&id=1526e626&scoped=true&"
import script from "./MarcaUpdate.vue?vue&type=script&lang=js&"
export * from "./MarcaUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1526e626",
  null
  
)

export default component.exports